import PlanetDetails from './planet-view';

export default PlanetDetails;
